import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export default async function fetchDayPlans({ planID }): Promise<any[]> {
  console.log("Getting DayPlans", planID);
  try {
    const dayPlansRef = firestore
      .collection(DB_PATH.PLAN_DAY)
      .where("planID", "==", planID);
    const snapshot = await dayPlansRef.get();

    const dayPlansPromises = snapshot.docs.map(async (doc) => {
      const dayPlan = doc.data();

      // Assuming steps are stored in a collection named 'steps' and have a field 'dayPlanID'
      const stepsRef = firestore
        .collection(DB_PATH.PLAN_STEP)
        .where("dayPlanID", "==", doc.id);
      const stepsSnapshot = await stepsRef.get();

      const steps = stepsSnapshot.docs.map((stepDoc) => stepDoc.data());

      // Incorporate steps into the day plan
      return { ...dayPlan, steps };
    });

    const dayPlans = await Promise.all(dayPlansPromises);

    return dayPlans;
  } catch (error) {
    console.error("Error fetching day plans:", error);
    throw error;
  }
}
